export const data = {
  buttons: [
    {
      label: 'Yes',
      id: 'yes',
    },
    {
      label: 'No',
      id: 'no',
    },
  ],
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/35a9c0e3cc29-tooliconmoney.jpg',
  },
  title: 'Did you pay for parking?',
}
